/* import __COLOCATED_TEMPLATE__ from './fly-banner.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
export let BannerState = /*#__PURE__*/function (BannerState) {
  BannerState["Success"] = "success";
  BannerState["Warning"] = "warning";
  BannerState["Error"] = "error";
  BannerState["Info"] = "info";
  BannerState["Action"] = "action";
  BannerState["Feature"] = "feature";
  BannerState["Default"] = "system";
  return BannerState;
}({});
export let BannerType = /*#__PURE__*/function (BannerType) {
  BannerType["Inline"] = "inline";
  BannerType["Alert"] = "alert";
  BannerType["Announcement"] = "announcement";
  return BannerType;
}({});
/**
  FlyBanner presents information to the user in context of an error, warning, success, etc. It can
  be used globally or inline with the surrounding context. Global banners are either an announcement
  or a floating alert over the content.

  Six states can be represented through the API: success, warning, error, info, system, and action.
  Each type of alert can be represented by all six states, leading to a total of 18 different
  display options.

  Other features can be customized such as the icon, whether it's closeable, and a primary action
  that can be taken.

  Finally, the body of the alert (aside from the title) is a block and isn't passed as an argument.

  ```hbs
  <FlyBanner
    \@icon="delete-trash"
    \@title="This is the title"
    \@state="success"
    \@type="inline"
    \@onClose={{this.onBannerClose}}
    \@onClick={{this.onBannerActionClick}}
    \@action="Reload"
  />
  ```

  @class FlyBanner
  @public
*/
let FlyBanner = (_class = class FlyBanner extends Component {
  get icon() {
    // `null` icon means no icon should display
    if (this.args.icon !== undefined) {
      return this.args.icon;
    }
    switch (this.args.state) {
      case BannerState.Success:
        return 'check-circle';
      case BannerState.Warning:
        return 'warning';
      case BannerState.Error:
        return 'error';
      case BannerState.Info:
        return 'help';
      case BannerState.Action:
      case BannerState.Feature:
        return 'feature-launch';
      default:
        return 'tip';
    }
  }
  get stateClass() {
    return `fly-banner--${this.args.state || BannerState.Default}`;
  }
  get actionButtonIconClass() {
    if (this.args.actionIcon == null) {
      return '';
    }
    return this.actionIconPosition === 'left' ? 'pl-1.5' : 'pr-1.5';
  }
  get actionButtonSizeClass() {
    if (!this.args.actionSize) {
      return '';
    }
    return `fly-btn--${this.args.actionSize}`;
  }
  get typeClass() {
    return `fly-banner--${this.args.type || BannerType.Inline}`;
  }
  get actionIconPosition() {
    return this.args.actionIconPosition ?? 'left';
  }
  onClickLinkAction(event) {
    if (this.args.dismissOnClick && this.args.onClose != null) {
      this.args.onClose(event);
    }
  }
  onClickButtonAction(event) {
    if (this.args.onClick != null) {
      this.args.onClick(event);
    }
    if (this.args.dismissOnClick && this.args.onClose != null) {
      this.args.onClose(event);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onClickLinkAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickLinkAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickButtonAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickButtonAction"), _class.prototype)), _class);
export { FlyBanner as default };